<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import Label from '$provider/constants/Label';

  interface Props {
    value?: string;
    key?: string;
    onevent?: (payload: { type: 'click-add'; key: string }) => void;
  }

  let { value = '', key = '', onevent }: Props = $props();

  const onClickAction = (): void => {
    onevent?.({ type: 'click-add', key });
  };
</script>

<div class="add-action-text-type">
  <div class="text">{value}</div>

  <button
    class="add-action"
    data-cy="add-action"
    onclick={(e) => { e.preventDefault(); e.stopPropagation(); onClickAction(); }}
  >
    <div class="plus-icon">
      <Icon fontSize={'11px'} size={'11px'} value="icon-plus grey" />
    </div>
    <div>{Label.Add}</div>
  </button>
</div>

<style>
  .add-action-text-type {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .add-action {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    color: var(--grey-medium);
  }
  .add-action:hover {
    background-color: var(--grey-bg-light);
  }
  .plus-icon {
    margin-right: 4px;
    writing-mode: vertical-lr;
  }
</style>
